// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/public/marketing.proto (package guardianai.v1.public, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/public/marketing.proto.
 */
export const file_guardianai_v1_public_marketing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * @generated from message guardianai.v1.public.PublicBlog
 */
export type PublicBlog = Message<"guardianai.v1.public.PublicBlog"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: string author = 5;
   */
  author: string;

  /**
   * @generated from field: optional string youtube_video_id = 6;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 7;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 8;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 10;
   */
  publishedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.public.PublicBlog
 */
export type PublicBlogJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string content = 4;
   */
  content?: string;

  /**
   * @generated from field: string author = 5;
   */
  author?: string;

  /**
   * @generated from field: optional string youtube_video_id = 6;
   */
  youtubeVideoId?: string;

  /**
   * @generated from field: optional string seo_description = 7;
   */
  seoDescription?: string;

  /**
   * @generated from field: optional string seo_keywords = 8;
   */
  seoKeywords?: string;

  /**
   * @generated from field: optional string og_image_url = 9;
   */
  ogImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 10;
   */
  publishedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.public.PublicBlog.
 * Use `create(PublicBlogSchema)` to create a new message.
 */
export const PublicBlogSchema: GenMessage<PublicBlog, {jsonType: PublicBlogJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 0);

/**
 * @generated from message guardianai.v1.public.ListPublicBlogsRequest
 */
export type ListPublicBlogsRequest = Message<"guardianai.v1.public.ListPublicBlogsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.public.ListPublicBlogsRequest
 */
export type ListPublicBlogsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.public.ListPublicBlogsRequest.
 * Use `create(ListPublicBlogsRequestSchema)` to create a new message.
 */
export const ListPublicBlogsRequestSchema: GenMessage<ListPublicBlogsRequest, {jsonType: ListPublicBlogsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 1);

/**
 * @generated from message guardianai.v1.public.ListPublicBlogsResponse
 */
export type ListPublicBlogsResponse = Message<"guardianai.v1.public.ListPublicBlogsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.public.PublicBlog blogs = 1;
   */
  blogs: PublicBlog[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.public.ListPublicBlogsResponse
 */
export type ListPublicBlogsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.public.PublicBlog blogs = 1;
   */
  blogs?: PublicBlogJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.public.ListPublicBlogsResponse.
 * Use `create(ListPublicBlogsResponseSchema)` to create a new message.
 */
export const ListPublicBlogsResponseSchema: GenMessage<ListPublicBlogsResponse, {jsonType: ListPublicBlogsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 2);

/**
 * @generated from message guardianai.v1.public.GetPublicBlogBySlugRequest
 */
export type GetPublicBlogBySlugRequest = Message<"guardianai.v1.public.GetPublicBlogBySlugRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;
};

/**
 * @generated from message guardianai.v1.public.GetPublicBlogBySlugRequest
 */
export type GetPublicBlogBySlugRequestJson = {
  /**
   * @generated from field: string slug = 1;
   */
  slug?: string;
};

/**
 * Describes the message guardianai.v1.public.GetPublicBlogBySlugRequest.
 * Use `create(GetPublicBlogBySlugRequestSchema)` to create a new message.
 */
export const GetPublicBlogBySlugRequestSchema: GenMessage<GetPublicBlogBySlugRequest, {jsonType: GetPublicBlogBySlugRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 3);

/**
 * @generated from message guardianai.v1.public.SubmitLeadRequest
 */
export type SubmitLeadRequest = Message<"guardianai.v1.public.SubmitLeadRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string source = 3;
   */
  source: string;
};

/**
 * @generated from message guardianai.v1.public.SubmitLeadRequest
 */
export type SubmitLeadRequestJson = {
  /**
   * @generated from field: string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string source = 3;
   */
  source?: string;
};

/**
 * Describes the message guardianai.v1.public.SubmitLeadRequest.
 * Use `create(SubmitLeadRequestSchema)` to create a new message.
 */
export const SubmitLeadRequestSchema: GenMessage<SubmitLeadRequest, {jsonType: SubmitLeadRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 4);

/**
 * @generated from message guardianai.v1.public.TrackVisitRequest
 */
export type TrackVisitRequest = Message<"guardianai.v1.public.TrackVisitRequest"> & {
  /**
   * @generated from field: string blog_id = 1;
   */
  blogId: string;
};

/**
 * @generated from message guardianai.v1.public.TrackVisitRequest
 */
export type TrackVisitRequestJson = {
  /**
   * @generated from field: string blog_id = 1;
   */
  blogId?: string;
};

/**
 * Describes the message guardianai.v1.public.TrackVisitRequest.
 * Use `create(TrackVisitRequestSchema)` to create a new message.
 */
export const TrackVisitRequestSchema: GenMessage<TrackVisitRequest, {jsonType: TrackVisitRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 5);

/**
 * @generated from message guardianai.v1.public.PublicCompanyAbout
 */
export type PublicCompanyAbout = Message<"guardianai.v1.public.PublicCompanyAbout"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string subtitle = 3;
   */
  subtitle?: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: optional string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 8;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 9;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 10;
   */
  githubUrl?: string;

  /**
   * @generated from field: optional string google_business_url = 11;
   */
  googleBusinessUrl?: string;

  /**
   * @generated from field: optional string google_maps_url = 12;
   */
  googleMapsUrl?: string;

  /**
   * @generated from field: optional string yelp_url = 13;
   */
  yelpUrl?: string;
};

/**
 * @generated from message guardianai.v1.public.PublicCompanyAbout
 */
export type PublicCompanyAboutJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: optional string subtitle = 3;
   */
  subtitle?: string;

  /**
   * @generated from field: string body = 4;
   */
  body?: string;

  /**
   * @generated from field: optional string hero_image_url = 5;
   */
  heroImageUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 8;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 9;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 10;
   */
  githubUrl?: string;

  /**
   * @generated from field: optional string google_business_url = 11;
   */
  googleBusinessUrl?: string;

  /**
   * @generated from field: optional string google_maps_url = 12;
   */
  googleMapsUrl?: string;

  /**
   * @generated from field: optional string yelp_url = 13;
   */
  yelpUrl?: string;
};

/**
 * Describes the message guardianai.v1.public.PublicCompanyAbout.
 * Use `create(PublicCompanyAboutSchema)` to create a new message.
 */
export const PublicCompanyAboutSchema: GenMessage<PublicCompanyAbout, {jsonType: PublicCompanyAboutJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 6);

/**
 * @generated from message guardianai.v1.public.PublicTeamMember
 */
export type PublicTeamMember = Message<"guardianai.v1.public.PublicTeamMember"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName: string;

  /**
   * @generated from field: string role_title = 3;
   */
  roleTitle: string;

  /**
   * @generated from field: string bio = 4;
   */
  bio: string;

  /**
   * @generated from field: optional string photo_url = 5;
   */
  photoUrl?: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder: number;

  /**
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 8;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 9;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 10;
   */
  githubUrl?: string;
};

/**
 * @generated from message guardianai.v1.public.PublicTeamMember
 */
export type PublicTeamMemberJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string full_name = 2;
   */
  fullName?: string;

  /**
   * @generated from field: string role_title = 3;
   */
  roleTitle?: string;

  /**
   * @generated from field: string bio = 4;
   */
  bio?: string;

  /**
   * @generated from field: optional string photo_url = 5;
   */
  photoUrl?: string;

  /**
   * @generated from field: int32 display_order = 6;
   */
  displayOrder?: number;

  /**
   * @generated from field: optional string website_url = 7;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string linkedin_url = 8;
   */
  linkedinUrl?: string;

  /**
   * @generated from field: optional string x_url = 9;
   */
  xUrl?: string;

  /**
   * @generated from field: optional string github_url = 10;
   */
  githubUrl?: string;
};

/**
 * Describes the message guardianai.v1.public.PublicTeamMember.
 * Use `create(PublicTeamMemberSchema)` to create a new message.
 */
export const PublicTeamMemberSchema: GenMessage<PublicTeamMember, {jsonType: PublicTeamMemberJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 7);

/**
 * @generated from message guardianai.v1.public.TeamPageResponse
 */
export type TeamPageResponse = Message<"guardianai.v1.public.TeamPageResponse"> & {
  /**
   * @generated from field: guardianai.v1.public.PublicCompanyAbout about = 1;
   */
  about?: PublicCompanyAbout;

  /**
   * @generated from field: repeated guardianai.v1.public.PublicTeamMember team_members = 2;
   */
  teamMembers: PublicTeamMember[];
};

/**
 * @generated from message guardianai.v1.public.TeamPageResponse
 */
export type TeamPageResponseJson = {
  /**
   * @generated from field: guardianai.v1.public.PublicCompanyAbout about = 1;
   */
  about?: PublicCompanyAboutJson;

  /**
   * @generated from field: repeated guardianai.v1.public.PublicTeamMember team_members = 2;
   */
  teamMembers?: PublicTeamMemberJson[];
};

/**
 * Describes the message guardianai.v1.public.TeamPageResponse.
 * Use `create(TeamPageResponseSchema)` to create a new message.
 */
export const TeamPageResponseSchema: GenMessage<TeamPageResponse, {jsonType: TeamPageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 8);

/**
 * @generated from message guardianai.v1.public.PublicWorkInPublicConfig
 */
export type PublicWorkInPublicConfig = Message<"guardianai.v1.public.PublicWorkInPublicConfig"> & {
  /**
   * @generated from field: string youtube_url = 1;
   */
  youtubeUrl: string;

  /**
   * live | scheduled | vod
   *
   * @generated from field: string session_status = 2;
   */
  sessionStatus: string;

  /**
   * @generated from field: string focus_area = 3;
   */
  focusArea: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.public.PublicWorkInPublicConfig
 */
export type PublicWorkInPublicConfigJson = {
  /**
   * @generated from field: string youtube_url = 1;
   */
  youtubeUrl?: string;

  /**
   * live | scheduled | vod
   *
   * @generated from field: string session_status = 2;
   */
  sessionStatus?: string;

  /**
   * @generated from field: string focus_area = 3;
   */
  focusArea?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.public.PublicWorkInPublicConfig.
 * Use `create(PublicWorkInPublicConfigSchema)` to create a new message.
 */
export const PublicWorkInPublicConfigSchema: GenMessage<PublicWorkInPublicConfig, {jsonType: PublicWorkInPublicConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 9);

/**
 * @generated from message guardianai.v1.public.PublicEngineConsoleGuideConfig
 */
export type PublicEngineConsoleGuideConfig = Message<"guardianai.v1.public.PublicEngineConsoleGuideConfig"> & {
  /**
   * @generated from field: string distro_engine_console_youtube_url = 1;
   */
  distroEngineConsoleYoutubeUrl: string;

  /**
   * @generated from field: string caption_engine_console_youtube_url = 2;
   */
  captionEngineConsoleYoutubeUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message guardianai.v1.public.PublicEngineConsoleGuideConfig
 */
export type PublicEngineConsoleGuideConfigJson = {
  /**
   * @generated from field: string distro_engine_console_youtube_url = 1;
   */
  distroEngineConsoleYoutubeUrl?: string;

  /**
   * @generated from field: string caption_engine_console_youtube_url = 2;
   */
  captionEngineConsoleYoutubeUrl?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message guardianai.v1.public.PublicEngineConsoleGuideConfig.
 * Use `create(PublicEngineConsoleGuideConfigSchema)` to create a new message.
 */
export const PublicEngineConsoleGuideConfigSchema: GenMessage<PublicEngineConsoleGuideConfig, {jsonType: PublicEngineConsoleGuideConfigJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_public_marketing, 10);

/**
 * @generated from service guardianai.v1.public.PublicMarketingService
 */
export const PublicMarketingService: GenService<{
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.ListBlogs
   */
  listBlogs: {
    methodKind: "unary";
    input: typeof ListPublicBlogsRequestSchema;
    output: typeof ListPublicBlogsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.GetBlogBySlug
   */
  getBlogBySlug: {
    methodKind: "unary";
    input: typeof GetPublicBlogBySlugRequestSchema;
    output: typeof PublicBlogSchema;
  },
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.SubmitLead
   */
  submitLead: {
    methodKind: "unary";
    input: typeof SubmitLeadRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.TrackVisit
   */
  trackVisit: {
    methodKind: "unary";
    input: typeof TrackVisitRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.GetTeamPage
   */
  getTeamPage: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof TeamPageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.GetWorkInPublicConfig
   */
  getWorkInPublicConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PublicWorkInPublicConfigSchema;
  },
  /**
   * @generated from rpc guardianai.v1.public.PublicMarketingService.GetEngineConsoleGuideConfig
   */
  getEngineConsoleGuideConfig: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof PublicEngineConsoleGuideConfigSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_public_marketing, 0);

